/**
 * The DataTransfer object is used to hold the data that is being dragged during a drag and drop operation
 */

export const containsFiles = (dataTransfer) => {
  if (dataTransfer.types) {
    for (var i = 0; i < dataTransfer.types.length; i++) {
      if (dataTransfer.types[i] == 'Files') {
        return true
      }
    }
  }

  return false
}
